export const environment = {
    baseUrl : "http://3.10.135.41:8080/api",
};
